module.exports = __webpack_public_path__ + "img/388.c366536d.jpg";